export const expoRegisterDevice = async () => {
  // Do nothing
}

export const expoUnregisterDevice = async () => {
  // Do nothing
}
